import React from 'react'
import Layout from '../Main/Layout'

import styled from 'styled-components'

import ButtonGroup from './ButtonGroup'
import TestamentBlock from '../TestamentBlock'

const Wrap = styled.div`
  text-align: center;
`

const Title = styled.h1`
  margin-top: 9rem;
  margin-bottom: 0.5rem;

  font-family: 'Source Sans Pro';
  font-size: 3.5rem;
  font-weight: bold;
  line-height: 4rem;
  color: #F2C94C;
  text-transform: uppercase;
`

const Subtitle = styled.h2`
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;

  font-family: 'Source Sans Pro';
  font-size: 3rem;
  font-weight: normal;
  line-height: 3.5rem;
  color: #F2C94C;
  text-transform: uppercase;
`

const TestamentBlocksWrap = styled.div`
  margin-top: 0.5rem;
`

const Home = (props) => (
  <Layout>
    <Wrap>
      <Title>God Vision Ministries</Title>
      <Subtitle>Urdu Audio Bible</Subtitle>
      <ButtonGroup links={[
        {url: '/download', title: 'Download'},
        {url: 'https://www.gvm.website/make-a-donation', title: 'Give now'},
        {url: '/sign-out', title: 'Sign out'},
      ]}/>
      <TestamentBlocksWrap>
        <TestamentBlock inline background={`${process.env.PUBLIC_URL}/img/old-testament-bg.jpg`} curve='CurveDown'>Old Testament</TestamentBlock>
        <TestamentBlock inline background={`${process.env.PUBLIC_URL}/img/new-testament-bg.jpg`} curve='CurveUp'>New Testament</TestamentBlock>
      </TestamentBlocksWrap>
    </Wrap>
  </Layout>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/index.js